var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.animationsEnabled)?_c('rive-animation',{ref:"animation",attrs:{"src":"/anim/chick.riv","alignment":"bottomLeft","fit":"fitWidth","disable-rive-listeners":_vm.isTouchDevice},on:{"load":_vm.onLoad}}):_c('img',{attrs:{"src":"/img/themes/easter/chick-fallback.svg","alt":"Easter illustration of a chick"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }